import React, { Fragment } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import { ITooltip, Text } from '../1elements'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import IconButton from '@mui/material/IconButton'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import AccountAvatar from '../3modules/TabWidgets/accountDetail/AccountAvatar'

const UserListItem = ({ user, index, deleteHandler, disabled }) => {
  const classes = useStyles()
  const userName = user.name
    ? user.name
    : user.userName
    ? user.userName
    : user.username
  const userEmail = user.email ? user.email : user.userEmail
  const avatar = user.avatar ? user.avatar : user.userAvatar
  const online = user.online || false

  const primaryContent = <Text type='detailNameDetailsHeader'>{userName}</Text>

  const secondaryContent = <Fragment>{userEmail}</Fragment>

  return (
    <Fragment key={index}>
      <ITooltip placement={'top'} content={`${userName} (${userEmail})`} arrow>
        <ListItem alignItems='flex-start' className={classes.listItem}>
          <ListItemAvatar>
            <AccountAvatar
              avatar={avatar}
              online={online}
              accountName={userName}
              className={classes.smImage}
            />
          </ListItemAvatar>

          <ListItemText primary={primaryContent} secondary={secondaryContent} />

          {deleteHandler && !disabled && (
            <ListItemSecondaryAction>
              <IconButton
                edge='end'
                aria-label='delete'
                className={classes.deleteButton}
                onClick={index => deleteHandler(index)}
              >
                <HighlightOffIcon />
              </IconButton>
            </ListItemSecondaryAction>
          )}
        </ListItem>
      </ITooltip>
      <Divider variant='fullWidth' />
    </Fragment>
  )
}

export default UserListItem

const useStyles = makeStyles({
  listItem: {
    padding: '0 auto',
    margin: '0',

    '& .MuiListItemText-secondary': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  deleteButton: {
    padding: '12px 0'
  },
  smImage: {
    width: 50,
    height: 50,
    '& img': {
      transform: 'scale(0.6)'
    }
  }
})
